import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	min-height: 56px;
	display: flex;
	align-items: center;
	border-bottom: 2px solid ${({ color }) => color || colors.grey2};
	padding: 0 48px 0 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	${({ hideCompanySelect }) =>
		hideCompanySelect ? 'padding-right: 16px' : ''};
`;

export const DropdownWrapper = styled.div`
	width: 100%;
	max-width: 500px;
	overflow: hidden;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	margin-left: auto;

	button {
		margin-left: 8px;
	}

	button:first-child svg {
		fill: ${colors.green1};
	}
`;

export const OptionLabel = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
`;

export const CompanyTitle = styled.div`
	max-width: 226px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const OptionInfo = styled.div`
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	padding-left: 8px;
	display: flex;
	align-items: center;
	white-space: nowrap;
`;
